import { string } from "prop-types";

const userDto = {
  id: 0,
  pwd: null,
  document: null,
  idTypeDocument: 0,
  typeDocument: null,
  userName: null,
  name: null,
  lastName: null,
  phone: null,
  email: null,
  idRole: 0,
  role: null,
  status: 1,
  idClient: null,
  client: null,
  img: null,
  imgExt: null,
  imgList: [],
  idUserCreated: 0,
  userCreated: null,
  idUserUpdated: 0,
  userUpdated: null,
  offices: string,
};

export default userDto;
